import { Form, FormikProps } from 'formik';
import * as React from 'react';
import {
    ActionList,
    AppFooter,
    AppSection,
    AppSectionHeader,
    ButtonPrimary,
    InputText,
    InputSwitch,
} from '../../components-v2/shared';

export interface IPropertyManagementCompany {
    id?: number;
    name: string;
    lead_summary_email_recipient?: string;
    send_lead_summary_email?: boolean;
}

export const labels = {
    name: 'Name',
    lead_summary_email_recipient: 'Lead Summary Email Recipient',
    send_lead_summary_email: 'Send Lead Summary Email',
};

interface ParentProps {
    controls: (bag: FormikProps<IPropertyManagementCompany>) => React.ReactNode;
    editing: boolean;
}

export default (props: ParentProps) => {
    return (bag: FormikProps<IPropertyManagementCompany>) => {
        return (
            <>
                <Form>
                    <AppSection>
                        <div className="field-group-content">
                            <div className="field-group-col">
                                <AppSectionHeader title="Property Management Company" />
                                <InputText name = "name" label="Property Management Company" formikProps={bag} />
                                <InputText name="lead_summary_email_recipient" label="Lead Summary Email Recipient" formikProps={bag} />
                                <InputSwitch name="send_lead_summary_email" label="Send Lead Summary Email" formikProps={bag} />
                            </div>
                        </div>
                    </AppSection>
                    <AppFooter sticky={true}>
                        <ActionList position="end">
                            <ButtonPrimary
                                type="submit"
                                onClick={() => props.controls}
                            >
                                {bag.isSubmitting ? 'Saving...' : 'Save'}
                            </ButtonPrimary>
                        </ActionList>
                    </AppFooter>
                </Form>
            </>
        );
    };
};
